import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import LoadingSpinner from '../components/global/LoadingSpinner';
import { useQuery } from '@tanstack/react-query';
import { User } from 'firebase/auth';
import { useOptionalTenant } from '../tenancy/TenantContext';
import { addTenantQueryToPath } from '../auth/adminAccess';

interface SuperAdminOnlyProps {
  element: JSX.Element;
}

const fetchSuperAdminStatus = async (user: User): Promise<boolean> => {
  const token = await user.getIdTokenResult(true);
  return token.claims.superAdmin === true;
};

const SuperAdminOnlyRoute: React.FC<SuperAdminOnlyProps> = ({ element }) => {
  const { user, loading } = useAuth();
  const tenantId = useOptionalTenant()?.tenantId;

  const superAdminQuery = useQuery({
    queryKey: ['superAdminStatus', user?.uid],
    queryFn: () => {
      if (user) {
        return fetchSuperAdminStatus(user)
      }
    },
    enabled: !!user,
  });

  if (loading || superAdminQuery.isLoading) {
    return <LoadingSpinner fullScreen />;
  }

  if (!user || !superAdminQuery.data) {
    return <Navigate to={tenantId ? addTenantQueryToPath('/admin', tenantId) : '/admin'} replace />;
  }

  return element;
};

export default SuperAdminOnlyRoute;
